import { useEffect, useState } from 'react';
import { usePublicClient } from 'wagmi';
import type { EstimateContractGasParameters } from 'viem';
import { useQuery } from '@tanstack/react-query';

export const addBuffer = (gas: bigint) => {
  return gas + (gas / BigInt(100)) * BigInt(50);
};

export const useEstimateContractGas = (
  args: EstimateContractGasParameters & {
    enabled?: boolean;
    query?: { enabled?: boolean };
  },
  deps: unknown[]
) => {
  const publicClient = usePublicClient();

  const [gas, setGas] = useState<bigint | undefined>();

  useEffect(() => {
    const load = async () => {
      if (!publicClient) {
        throw new Error('No public client available');
      }

      try {
        const gas = await publicClient.estimateContractGas(args);
        setGas(addBuffer(gas));
      } catch (e) {
        console.log('estimate gas error', e);
      }
    };

    if (args.query?.enabled || args.enabled) {
      load();
    }
  }, deps);

  return gas;
};

export const useQueryEstimateContractGas = (
  args: EstimateContractGasParameters & {
    query: { enabled?: boolean; queryKey: readonly unknown[] };
  }
) => {
  const publicClient = usePublicClient();

  return useQuery({
    queryKey: ['estimateContractGas', ...args.query.queryKey],
    queryFn: async () => {
      if (!publicClient) {
        throw new Error('No public client available');
      }

      const gas = await publicClient.estimateContractGas(args);
      return addBuffer(gas);

      return BigInt(0);
    },
    enabled: args.query.enabled,
  });
};
